import { Link } from "react-router-dom"
import searchIcon from './icons/search.png'
import addIcon from './icons/add-circle-outline.png'
import postIcon from './icons/photo-outline.png'
import notificationsIcon from './icons/notifications.png'
import latestIcon from './icons/atest.png'
import dogsIcon from './icons/dog-barking-outline.png'
import usersIcon from './icons/person.png'
import { NotificationCard } from "./mini-components/notification-card"



export const AdminMainContent = () => {

    const notifications = [
        "This feature is not yet available",
        "No notifications yet",
        "No notifications yet",
        "No notifications yet",
        "No notifications yet",
    ]

    const displayNotifications = () => {
        return notifications.map((item) => {
            return <NotificationCard notification={item}/>
        })
    }
    return (
        <div className="container-fluid justify-content-around pt-3 bg-white">
            <div className="row align-items-center justify-content-around ">
                <div className="col-sm-3 px-4 py-4 
            
                brand-yellow-box-shadow">
                    <div className="row align-items-center justify-content-center">
                        <img src={dogsIcon} />

                        <div> <div> {"N/A"}</div> dogs</div>
                    </div>
                </div>
                <div className="col-sm-3 px-4 py-4 brand-yellow-box-shadow">
                    <div className="row align-items-center justify-content-center">
                        <img src={usersIcon} />

                        <div> <div> {"N/A"}</div> users</div>
                    </div>
                </div>
                <div className="col-sm-3 px-4 py-4 brand-yellow-box-shadow">
                    <div className="row align-items-center justify-content-center">
                        <img src={dogsIcon} />

                        <div> <div> {"N/A"}</div> engagements</div>
                    </div>
                </div>
            </div>
            <hr />

            <div className="row align-items-center
            my-1 justify-content-center bg-white py-4 mb-3" >
                <div className="col-sm-10 px   -4 pb-4">
                    <div className="row justify-content-center align-items-center">
                        <div className="w-100">
                            {displayNotifications()}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row align-items-center 
            justify-content-center bg-white">
                <div className="col-sm-10 px   -4 py-4 ">
                    <div className="row justify-content-center align-items-center">
                        <img src={latestIcon} />

                        <span className="">Last registered dogs</span>
                    </div>
                </div>
            </div>

        </div>
    )
}